/*
  * Copyright Amazon.com, Inc. and its affiliates. All Rights Reserved.
  * SPDX-License-Identifier: MIT
  *
  * Licensed under the MIT License. See the LICENSE accompanying this file
  * for the specific language governing permissions and limitations under
  * the License.
  */

import axios from 'axios';
import jwt_decode from 'jwt-decode';
import { setCookie, eraseCookie } from './cookieHelper';

/** access/id Cookie 切れ後の refresh 用に、トークン発行元 client_id を保持する Cookie 名 */
export const TOKEN_CLIENT_ID_COOKIE = 'token_client_id';

export async function storeTokens(authorization_code, idToken, accessToken, refreshToken) {
	/*
	 * Call storage endpoint to store tokens in DynamoDB
	 */
	var response = await axios.post(
		'/storage',
		{
			authorization_code: authorization_code,
			id_token: idToken,
			access_token: accessToken,
			refresh_token: refreshToken
		},
		{ headers: { 'Content-Type': 'application/json' } }
	)
	return response;
}

export function setTokenCookie(type, token) {
	let tokenDecoded = jwt_decode(token);
	let tokenExpiry = tokenDecoded['exp'];
	setCookie(type, token, tokenExpiry);
}

export function setRefreshTokenCookie(refreshToken, accessToken) {
	// Fast SSO / 設定画面セッション復元用に、access より長く保持する（最大 30 日）
	const REFRESH_COOKIE_MAX_AGE_SEC = 30 * 24 * 60 * 60;
	const tokenExpiry = Math.floor(Date.now() / 1000) + REFRESH_COOKIE_MAX_AGE_SEC;
	setCookie("refresh_token", refreshToken, tokenExpiry);

	// access Cookie は JWT exp で消えるため、refresh 時の発行元特定用に別に保持する
	try {
		const clientId = jwt_decode(accessToken).client_id;
		if (clientId) {
			setCookie(TOKEN_CLIENT_ID_COOKIE, clientId, tokenExpiry);
		}
	} catch (e) {
		// ignore
	}
}

/** Fast SSO 用トークン Cookie をすべて削除する */
export function eraseTokenCookies() {
	eraseCookie("id_token");
	eraseCookie("access_token");
	eraseCookie("refresh_token");
	eraseCookie(TOKEN_CLIENT_ID_COOKIE);
}
